import { cn } from '@lair-finance/util'
import { AssetItem } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/AssetItem.tsx'
import { TokenAddresses } from '@/shared/config/token.ts'
import { useTokenBalance } from '@/shared/lib/wagmi/hooks/useTokenBalance.ts'
import { ActiveChain } from '@/domains/chain'
import { formatAssetAmount } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/lib/formatAssetAmount.ts'

export function WalletAssetListInjectiveTestnet({ className }: { className?: string }) {
  const chainId = ActiveChain.INJECTIVE.id
  const { balance: balanceINJ = '0' } = useTokenBalance({ chainId, watch: true })
  const { balance: balanceLsINJ = '0' } = useTokenBalance({
    chainId,
    tokenAddress: TokenAddresses[chainId].LsINJ,
    watch: true,
  })

  return (
    <div className={cn('flex flex-col gap-y-1', className)}>
      <AssetItem ticker={'INJ'} amount={formatAssetAmount(balanceINJ)} />
      <AssetItem ticker={'LsINJ'} amount={formatAssetAmount(balanceLsINJ)} />
    </div>
  )
}
